import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { useIndentInToggle } from '../../hooks/useIndentInToggle'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const IndentInButton = observer(() => {
  const { active, disabled, handleClick } = useIndentInToggle()

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.IndentIncrease} />}
      label="Indent In"
      active={active}
      disabled={disabled}
      handleClick={handleClick}
    />
  )
})
